import Service from "@/services/modules/charges.service";

const contacts = async ({ commit }, _object) => {
  const response = Service.contacts(_object);

  response.then(function(_response) {});

  return response;
};

const sendSlips = async ({ commit }, _object) => {
  const response = Service.sendSlips(_object);

  response.then(function(_response) {
    return _response;
  });

  return response;
};

const salesmanEvaluations = async ({ commit }, _object) => {
  const response = Service.salesmanEvaluations(_object);

  response.then(function(_response) {
    return _response;
  });

  return response;
};

const Evaluation = async ({ commit }, _object) => {
  const response = Service.Evaluation(_object);

  response.then(function(_response) {
    return _response;
  });

  return response;
};

const add = async ({ commit }, _object) => {
  const response = Service.add(_object);

  response.then(function(_response) {
    commit("add", _response);
  });

  return response;
};

const all = async ({ commit }, _itens) => {
  const response = Service.all(_itens.limit, _itens.page, _itens.params);

  response.then(function(_response) {
    commit("setList", _response.data);
  });

  return response;
};

const edit = async ({ commit }, _obj) => {
  const response = Service.edit(_obj.id, _obj);

  response.then(function(_response) {
    commit("setObject", _response);
  });

  return response;
};

const get = async ({ commit }, _id) => {
  const response = Service.get(_id);

  response.then(function(_response) {
    commit("setObject", _response);
  });

  return response;
};

const rem = async ({ commit }, _module) => {
  const response = Service.rem(_module.id);

  return response;
};

export default {
  add,
  all,
  edit,
  get,
  rem,
  contacts,
  sendSlips,
  salesmanEvaluations,
  Evaluation
};
